<template>
  <div class="tour-worldmap">
    <div ref="mapContainer" class="map-container"></div>
  </div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

export default {
  name: "TourWorldmap",
  props: {
    markers: {
      type: Array,
      required: true,
      default: () => [],
    },
    center: {
      type: Array,
      default: () => [20, 0],
    },
    zoom: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      map: null,
      markerCluster: null,
    };
  },
  watch: {
    markers: {
      handler() {
        this.renderMarkers();
      },
      deep: true,
    },
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      this.map = L.map(this.$refs.mapContainer).setView(this.center, this.zoom);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap contributors",
      }).addTo(this.map);

      this.markerCluster = L.markerClusterGroup({
        showCoverageOnHover: false,
        maxClusterRadius: 60,
        spiderfyOnMaxZoom: true,
      });

      this.map.addLayer(this.markerCluster);
      this.renderMarkers();
    },

    renderMarkers() {
      if (!this.map || !this.markerCluster) return;

      // 1) clear out old markers
      this.markerCluster.clearLayers();

      // 2) add new markers
      const valid = this.markers.filter(
        m =>
          Array.isArray(m.latlng) &&
          m.latlng.length === 2 &&
          typeof m.latlng[0] === "number" &&
          typeof m.latlng[1] === "number"
      );

      valid.forEach(m => {
        const marker = L.marker(m.latlng);
        if (m.popup) {
          marker.bindPopup(m.popup);
        } else if (m.name) {
          marker.bindPopup(m.name);
        }
        this.markerCluster.addLayer(marker);
      });

      // 3) fit map to show *all* markers at once
      const bounds = this.markerCluster.getBounds();
      if (bounds.isValid()) {
        this.map.fitBounds(bounds, { padding: [50, 50] });
      }
    },
  },
};
</script>

<style scoped>
.tour-worldmap {
  padding: 10px;
  margin-top: 30px;
  background: rgba(3, 8, 20, 0.85);
  border: 2px solid #00ffe7;
  border-radius: 16px;
  box-shadow: 0 0 20px #00ffe7;
  animation: pulse-border 3s infinite ease-in-out;
  position: relative;
  z-index: 1;
}

.map-container {
  height: 400px;
  width: 100%;
  border-radius: 12px;
}

@keyframes pulse-border {
  0% {
    box-shadow: 0 0 10px #00ffe7;
  }
  50% {
    box-shadow: 0 0 20px #00ffe7, 0 0 30px #1effff;
  }
  100% {
    box-shadow: 0 0 10px #00ffe7;
  }
}
</style>
